// Wordmark logos for motorcycle/ATV brands without svg icons in react-icons.
// Uses the display font family for a stylized text logo.

const base = "font-display font-black tracking-tight leading-none select-none";

export const HarleyLogo = (props) => (
  <div {...props} className={`${base} text-center ${props.className || ""}`}>
    <div className="text-[0.55em] tracking-[0.35em] uppercase text-[#FF8A82]">Harley</div>
    <div className="uppercase">Davidson</div>
  </div>
);

export const KawasakiLogo = (props) => (
  <div {...props} className={`${base} uppercase italic ${props.className || ""}`}>
    Kawasaki
  </div>
);

export const TriumphLogo = (props) => (
  <div {...props} className={`${base} uppercase ${props.className || ""}`}>
    Triumph
  </div>
);

export const IndianLogo = (props) => (
  <div {...props} className={`${base} text-center ${props.className || ""}`}>
    <div className="uppercase">Indian</div>
    <div className="text-[0.4em] tracking-[0.35em] uppercase text-[#FF8A82] mt-1">Motorcycle</div>
  </div>
);

export const PolarisLogo = (props) => (
  <div {...props} className={`${base} uppercase italic ${props.className || ""}`}>
    Polaris
  </div>
);

export const CanAmLogo = (props) => (
  <div {...props} className={`${base} uppercase ${props.className || ""}`}>
    Can‑Am
  </div>
);

export const ApriliaLogo = (props) => (
  <div {...props} className={`${base} uppercase ${props.className || ""}`}>
    Aprilia
  </div>
);

export const ArcticCatLogo = (props) => (
  <div {...props} className={`${base} uppercase text-center ${props.className || ""}`}>
    <div>Arctic</div>
    <div className="text-[#FF8A82]">Cat</div>
  </div>
);
